import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout, onFeedbackClick }) {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <img src="/logo.png" alt="LaTeXLaB" className="nav-logo" />
        </div>

        <div className="nav-links">
          <a href="/#features" className="nav-link">Features</a>
          <a href="/#templates" className="nav-link">Templates</a>

          <div className="nav-btn-wrapper">
            {user?.email === 'latexlab2026@gmail.com' ? (
              <button
                className="btn btn-word-latex"
                onClick={() => navigate('/convert')}
              >
                Word → LaTeX
              </button>
            ) : (
              <>
                <button
                  className="btn btn-word-latex"
                  disabled
                >
                  Word → LaTeX
                  <span className="beta-badge">Beta</span>
                </button>
                <div className="coming-soon-tooltip">
                  Coming Soon
                </div>
              </>
            )}
          </div>

          <a
            href="mailto:latexlab2026@gmail.com"
            className="nav-link"
          >
            Help
          </a>

          {user && !user.isPro && (
            <a
              href="https://latexlab.lemonsqueezy.com/checkout/buy/1a74bd46-1574-43f3-b0c5-e827847c6462?desc=0"
              target="_blank"
              rel="noreferrer"
              className="btn-go-pro"
            >
              Go Pro
            </a>
          )}
          <button
            onClick={onFeedbackClick}
            className="btn-feedback"
          >
            💬 Feedback
          </button>

          {user ? (
            <>
              <button
                className="nav-link-btn"
                onClick={() => navigate('/editor')}
              >
                My Editor
              </button>
              <div className="nav-user-group">
                <div className="nav-user">
                  <span className="user-name">{user.name}</span>
                  <button
                    className="btn btn-logout"
                    onClick={onLogout}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <button 
                className="btn btn-outline"
                onClick={() => navigate('/login')}
              >
                Login
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/register')}
              >
                Sign Up Free
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
